export default __webpack_public_path__ + "./fonts/i.fdaa9584.svg";